import request from '@/utils/request'


// 查询客服商户列表
export function listCustomerSeller(query) {
  return request({
    url: '/customer/seller/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询客服商户分页
export function pageCustomerSeller(query) {
  return request({
    url: '/customer/seller/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询客服商户详细
export function getCustomerSeller(data) {
  return request({
    url: '/customer/seller/detail',
    method: 'get',
    params: data
  })
}

export function openCustomer(data) {
  return request({
    url: '/customer/seller/open-customer-setting',
    method: 'get',
    params: data
  })
}



// 新增客服商户
export function addCustomerSeller(data) {
  return request({
    url: '/customer/seller/add',
    method: 'post',
    data: data
  })
}

// 修改客服商户
export function updateCustomerSeller(data) {
  return request({
    url: '/customer/seller/edit',
    method: 'post',
    data: data
  })
}

// 删除客服商户
export function delCustomerSeller(data) {
  return request({
    url: '/customer/seller/delete',
    method: 'post',
    data: data
  })
}
